module.exports = __webpack_public_path__ + "275c7b45a6cb7dbd2f1772cc78e996df.otf";